<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    v-if="this.$store.getters['auth/userStatus'] === true"
    placement="bottom-end"
    add-menu-classes="pt-0 pb-0 text-hover dropdown-menu-ch1 mt-3 bg-transparent border-0"
    style="transform: translate3d(-123px, 55px)"
  >
    <template #toggler>
      <CHeaderNavLink style="display: flex; margin-right: 16px">
        <div class="c-avatar mt-2">
          <img
            v-if="userinfo.image_profile"
            class="c-avatar-img"
            :src="userinfo.image_profile"
          />
          <div class="text-center" v-else>
            <i class="fa fa-user"></i>
          </div>
        </div>
        <p class="mb-0 mt-2 mr-2 ml-1 d-md-down-none mx-2 display-name">
          {{ userinfo.displayname }}
        </p>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader class="dropdown-header-ch1">
      <strong>MENU</strong>
    </CDropdownHeader>
    <!--
    <CDropdownItem>
      <CBadge class="dropdown-item-ch1" style="color:#014BB6;">GO TO MANAGE COURSE</CBadge>
      <CIcon class="ml-auto icon-right mt-1" style="color:#014BB6;" name="cil-settings" />
    </CDropdownItem>
    -->
    <!--
    <CDropdownItem class="icon-right-invert" v-on:click="accountManagement('lp')">
      <CBadge class="dropdown-item-ch1">LEARNING PROFILE</CBadge>
      <img
        style="width:18px; hight:18px;"
        class="ml-auto mr-1 icon-right mt-1"
        src="@/assets/icons/PaymentHistory.svg"
      />
    </CDropdownItem>
    -->

    <CDropdownItem
      v-if="$store.getters['profile/getUserType'] == 20 || $store.getters['profile/getUserType'] == 99"
      class="icon-right-invert"
      v-on:click="goToAdminPage()"
    >
      <CBadge class="dropdown-item-ch1">COURSES MANAGEMENT</CBadge>
      <c-icon class="ml-auto mr-1 icon-right mt-1" name="cilSettings"></c-icon>
      <!-- <img
        style="width:18px; height:18px;"
        class="ml-auto mr-1 icon-right mt-1"
        src="@/assets/icons/Certificate.svg"
      /> -->
    </CDropdownItem>
    <CDropdownItem
      class="icon-right-invert"
      v-on:click="accountManagement('am')"
    >
      <CBadge class="dropdown-item-ch1">ACCOUNT MANAGEMENT</CBadge>
      <img
        style="width: 18px; height: 18px"
        class="ml-auto mr-1 icon-right mt-1"
        src="@/assets/icons/Profile Icon 2.svg"
      />
    </CDropdownItem>

   <!-- <CDropdownItem
      class="icon-right-invert"
      v-on:click="accountManagement('cp')"
    >
       <CBadge class="dropdown-item-ch1">CHANGE PASSWORD</CBadge> 
      <img
        style="width: 14px; hight: 14px"
        class="ml-auto mr-1 icon-right mt-1"
        src="@/assets/icons/Key.svg"
      />
    </CDropdownItem>-->
    <!--
    <CDropdownItem class="icon-right-invert" v-on:click="accountManagement('pm')">
      <CBadge class="dropdown-item-ch1">PAYMENT METHODS</CBadge>
      <img
        style="width:20px; hight:20px;"
        class="ml-auto mr-1 icon-right mt-1"
        src="@/assets/icons/Payment.svg"
      />
    </CDropdownItem>
    -->
    <!--
    <CDropdownItem class="icon-right-invert" v-on:click="accountManagement('ph')">
      <CBadge class="dropdown-item-ch1">PURCHASED HISTORY</CBadge>
      <img
        style="width:20px; hight:20px;"
        class="ml-auto mr-1 icon-right mt-1"
        src="@/assets/icons/PaymentHistory.svg"
      />
    </CDropdownItem>
    -->
    <!--
    <CDropdownItem class="icon-right-invert" v-on:click="accountManagement('mc')">
      <CBadge class="dropdown-item-ch1">MY CERTIFICATE</CBadge>
      <img
        style="width:20px; hight:20px;"
        class="ml-auto mr-1 icon-right mt-1"
        src="@/assets/icons/Certificate.svg"
      />
    </CDropdownItem>
    -->
    <CDropdownHeader class="footer-drop pt-0 pl-0 pr-0 pb-0" @click="logout">
      <CButton class="bt-footer footer-drop text-left">
        <strong class="dropdownfooter-ch1">LOG OUT</strong>
      </CButton>
    </CDropdownHeader>
  </CDropdown>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  profileImage: false,
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      selectIndexImage: "",
      name: "",
      userinfo: {
        displayname: "",
        image_profile: "",
        image_collection: "",
      },
    };
  },
  created() {},
  mounted() {
    if (this.$store.getters["auth/userStatus"]) {
      this.$store.dispatch("profile/getUserProfile");
      this.onLoadUserInfo();
    }
  },
  computed: {
    ...mapGetters({
      getUserInfo: "profile/getProfile",
      nameStore: "auth/userInformation",
    }),
  },
  watch: {
    getUserInfo(value) {
      this.userinfo = value.userinfo;
      this.education = value.education;
    },
    imgURL: function() {
      this.profileImage = false;
    },
    nameStore(value) {
      this.name = value.userinfo.displayname;
      this.selectIndexImage = value.userinfo.image_profile;
    },
  },
  // mounted(){
  //   if(this.$store.getters['profile.getProfile']!==null){
  //     this.selectIndexImage = this.$store.getters["auth/userInformation"].userinfo.image_profile,
  //     this.name = this.$store.getters["auth/userInformation"].data.userProfile.userinfo.userinfo.displayname
  //   }
  // },
  methods: {
    goToAdminPage() {
      this.$store.commit("language/setChangingSidebar", true);
      this.$router.push("/course-management/courses-overview");
    },
    accountManagement: function(signal) {
      this.$router.push({
        name: "MainProfile",
        params: {
          signal: signal,
        },
      });
    },
    Getprofile() {
      this.$router.push("MainProfile");
    },
    logout() {
      this.$gAuth
        .signOut()
        .then(() => {
          console.log("logout successfully");
        })
        .catch((err) => {});
      this.$store.dispatch("auth/logout");
    },
    onLoadUserInfo() {
      this.$store.dispatch("fetchUserDataByToken");
    },
    getResult() {
      const canvas = this.$refs.clipper.clip(); //call component's clip method
      this.selectIndexImage = canvas.toDataURL("image/jpeg", 1); //canvas->image

      let i;
      for (i = 0; i < this.arrayOfImage.length; i++) {
        this.arrayOfImage[i].selected = false;
      }
      let payload = {
        imageData: this.selectIndexImage,
        selected: true,
      };
      this.arrayOfImage.unshift(payload);
      this.changeProfileModal = false;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap");
.dropdown-menu-ch1 {
  border: 0px;
  border-radius: 20px;
  width: 270px;
  height: auto;
  transform: translate3d(-123px, 55px);
  -webkit-box-shadow: 10px 15px 20px 1px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 10px 15px 20px 1px rgba(0, 0, 0, 0.5);
  box-shadow: 10px 15px 20px 1px rgba(0, 0, 0, 0.5);
}

.Customrow {
  margin-right: 1px;
  margin-left: -1px;
}

.display-name {
  color: black;
  font-family: "Roboto";
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  padding-top: 0.2em;
}
.dropdown-header-ch1 {
  color: black;
  font-family: "Roboto";
  font-weight: 400;
  font-size: 16px;
  opacity: 1;
  border-radius: 20px 20px 0px 0px;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  background-color: rgba(255, 255, 253, 0.5);
}

.footer-drop {
  color: black;
  font-family: "Roboto";
  font-weight: 400;
  font-size: 16px !important;
}
.bt-footer {
  width: 270px;
  float: left;
  text-align: left;
  opacity: 1;
  border-radius: 0px 0px 20px 20px;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  background-color: rgba(255, 255, 253, 0.5);
}

.footer-drop :hover {
  background-color: transparent;
  color: red;
}

.dropdown-item {
  font-family: "Roboto";
  font-weight: 500;
  font-size: 16px;
  background-color: #fff !important;
}

.dropdownfooter-ch1 {
  margin-left: 0.8em;
  color: black;
}

.dropdownfooter-ch1:hover {
  font-family: "Roboto";
  font-weight: 500;
  font-size: 16px;
}
</style>

<style scoped>
.dropdown-menu {
  border-radius: 20px;
}
.c-avatar {
  font-size: 15px;
  width: 26px;
  height: 26px;
  background-color: #666;
  color: #fff;
  display: inline;
}
.c-avatar-img {
  /* border-radius: 50%; */
  width: 26px;
  height: 26px;
  object-fit: cover;
}

.c-icon {
  margin-right: 0.3rem;
}

.dropdownfooter-ch1:hover {
  background-color: transparent;
  color: red;
}

.dropdown-item-ch1 {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 5px;
  padding-top: 5px;
  font-family: "Roboto";
  font-weight: bold;
  font-size: 16px;
}

.icon-right {
  float: right;
}

.dropdown-item:hover {
  /* background-color: #0080ff; */
  background-color: #ffa800;
  color: black !important;
  /* filter: invert(100%); */
}

a {
  color: inherit;
}

.icon-right-invert:hover {
  filter: invert(100%);
}

@media only screen and (max-width: 575px) {
  .c-avatar {
    display: none;
  }
  .c-header-nav-items {
    display: none;
  }
}
</style>
